.reactGridWrapper {
    display: block;
}

.reactGridLayout {
    width: 100%;
    height: 100%;
}
